import { render, staticRenderFns } from "./HeaderProgramCard.vue?vue&type=template&id=756d220a&scoped=true&"
import script from "./HeaderProgramCard.vue?vue&type=script&lang=js&"
export * from "./HeaderProgramCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756d220a",
  null
  
)

export default component.exports